import { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { UserContext } from '../contexts/UserContext';
import { OrganizationsProvider } from '../contexts/OrganizationsContext';
import AdminDashboard from "./Dashboards/AdminDashboard";
import TeacherDashboard from "./Dashboards/TeacherDashboard";
import CsoDashboard from "./Dashboards/CsoDashboard";
import StudentDashboard from "./Dashboards/StudentDashboard";
import { OrganizationJobsContextProvider } from "../contexts/OrganizationJobsContext";
import { ToastContainer } from "react-toastify";
import TeacherLayout from "./Dashboards/TeacherLayout";
import { HallPassTypesProvider } from "../contexts/HallPassTypesContext";
import { HallPassesProvider } from "../contexts/HallPassesContext";
import LoadingAcorn from "./LoadingAcorn";
import { NotificationToast } from "./common/NotificationToast";
// Interface for Weather Forecast data
// interface Forecast {
//     date: string;
//     temperatureC: number;
//     temperatureF: number;
//     summary: string;
// }

function App() {
    // const [error] = useState<string | null>(null);
    // const [orgId, setOrgId] = useState<string | null>(null);
    //const navigate = useNavigate();
    //const { userProfile, setUserProfile, isLoading } = useContext(UserContext);
    const { userProfile, isLoading } = useContext(UserContext);
    // const { organizations } = useOrganizations();

    useEffect(() => {
        if (userProfile?.orgId) {

            //setOrgId(userProfile.orgId.toString());
        }
    }, [userProfile]);

    if (isLoading) {
        return <LoadingAcorn />;
    }

    // Handle organization change
    // const handleOrgChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    //     setOrgId(event.target.value);
    // };

    const role = userProfile?.mainRole; // get the primary role

    let ComponentToRender;
    switch (role) {
        case "ACORNJRADMIN":
        case "ADMIN":
            ComponentToRender = (
                <OrganizationsProvider>
                    <HallPassesProvider>
                        <AdminDashboard />
                    </HallPassesProvider>
                </OrganizationsProvider>
            );
            break;
        case "CAMPUSSECURITYOFFICER":
            ComponentToRender = (
                <OrganizationJobsContextProvider>
                    <HallPassTypesProvider>
                        <HallPassesProvider>
                            <CsoDashboard />
                        </HallPassesProvider>
                    </HallPassTypesProvider>
                </OrganizationJobsContextProvider>
            );
            break;
        default:
            if ((role && role.includes("TEACHER")) || role && role.includes("ACORNLEAD")) {
                ComponentToRender = (
                    <OrganizationsProvider>
                        <OrganizationJobsContextProvider>
                            <HallPassTypesProvider>
                                <HallPassesProvider>
                                    <TeacherLayout>
                                        <TeacherDashboard />
                                    </TeacherLayout>
                                </HallPassesProvider>
                            </HallPassTypesProvider>
                        </OrganizationJobsContextProvider>
                    </OrganizationsProvider>
                );
                break;
            }
            else
                ComponentToRender = <HallPassTypesProvider><HallPassesProvider><StudentDashboard /></HallPassesProvider></HallPassTypesProvider>;
    }

    return userProfile ? (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 12000 }}
            />
            <NotificationToast />
            {/* Environment Indicator */}
            {process.env.NODE_ENV !== 'PROD' && process.env.NODE_ENV && (
                <span
                    className={`block w-full text-center text-xs mb-2 ${process.env.NODE_ENV === "demo"
                        ? "bg-blue-600"
                        : process.env.NODE_ENV === "test"
                            ? "bg-orange-600"
                            : process.env.NODE_ENV === "development"
                                ? "bg-purple-600"
                                : "bg-blue-600"
                        } text-white`}
                    style={{ zIndex: 9999, opacity: 0.5 }}
                >
                    ({process.env.NODE_ENV.toUpperCase()})
                    <br />
                </span>
            )}
            {ComponentToRender}
        </div>
    ) : (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col items-center justify-center p-4">
            {/* Logo */}
            <div className="mb-8">
                <img
                    src="https://i.imgur.com/UE5wDds.png"
                    alt="AcornJr Logo"
                    className="w-16 h-16"
                />
            </div>

            {/* Title */}
            <h1 className="text-3xl md:text-3xl font-bold text-center mb-4">
                {process.env.NODE_ENV !== 'PROD' && process.env.NODE_ENV && (
                    <span
                        className={`text-4xl ml-2 ${process.env.NODE_ENV === "demo"
                            ? "text-blue-600"
                            : process.env.NODE_ENV === "test"
                                ? "text-orange-600"
                                : process.env.NODE_ENV === "development"
                                    ? "text-purple-600"
                                    : "text-blue-600"
                            }`}
                    >
                        ({process.env.NODE_ENV.toUpperCase()})
                        <br />
                    </span>
                )}
                Choose how to enter your class
            </h1>

            {/* Login Options Grid */}
            <div >
                {/* Google Sign In Option */}
                <button
                    onClick={() => {
                        try { localStorage.setItem('acorn:preferredAuth', 'google'); } catch {}
                        window.location.href = `${process.env.API_URL || process.env.VITE_API_URL}/api/account/signingoogle?returnUrl=${encodeURIComponent(window.location.origin)}`;
                    }
                    }
                    className="flex flex-col items-center group p-6 backdrop-blur-md rounded-xl shadow-sm border border-gray-200/50 hover:bg-white/80 transition-all"
                >
                    <div className="w-32 h-32 bg-white rounded-2xl flex items-center justify-center mb-4 border border-gray-200/50 group-hover:shadow-lg transition-shadow">
                        <img
                            src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png"
                            alt="Google"
                            className="w-16 h-auto"
                        />
                    </div>
                    <h2 className="text-gray-900 font-semibold text-lg mb-2">
                        Sign in with Google
                    </h2>
                    <p className="text-gray-600 text-center text-sm">
                        Use a school provided google login
                    </p>
                </button>
            </div>

            {/* Login Link */}
            <div className="mt-12 text-center">
                <p className="text-gray-600 mb-2">Have a username?</p>
                <div className="flex items-center justify-center gap-4">
                    <Link
                        to="/login"
                        className="text-gray-800 font-semibold hover:text-gray-600 transition-colors inline-flex items-center"
                    >
                        <LogIn className="w-4 h-4 mr-1" />
                        Log in here
                    </Link>
                    <span hidden className="text-gray-400">|</span>
                    <Link hidden
                        to="/signup"
                        className="text-gray-800 font-semibold hover:text-gray-600 transition-colors"
                    >
                        Sign up
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default App;
